import type { IntlShape } from 'react-intl'

export function generateStaticMonthCaptions(
  intl: IntlShape,
  dayPrices?: { [isoDate: string]: App.Property.CalendarDay } | undefined,
): { [isoYearMonth: string]: React.ReactNode } | undefined {
  if (!dayPrices) return
  const caption = intl.formatMessage({
    id: 'UsinlOE-MHv0HTx5kQOp',
    defaultMessage: 'Approximate nightly price for 2 adults',
    description: 'Caption under a calendar month with prices, saying each day shows an approximate nightly price for 2 adults; the currency is shown in each day cell',
  })
  const isoYearMonthsWithPrices = [...new Set(Object.keys(dayPrices).map((isoDate) => isoDate.slice(0, 7)))]
  return Object.fromEntries(isoYearMonthsWithPrices.map((isoYearMonth) => [isoYearMonth, caption]))
}
